<template>
  <div>
    <v-card class="card--shadow">
      <v-card-title class="purple accent-4">
        <div class="subtitle-1 white--text text-uppercase">
          Presumptive Register Form 
        </div>
      </v-card-title>
      <v-card-text>
        <!--PRESUMPTIVE PATIENT INFO SECTION -->
        <div v-if="presumptiveDataEach">
          <v-row>
            <v-col lg="4">
              <v-row>
                <v-col class="header" lg="6">
                  <h3>Code</h3>
                </v-col>
                <v-col lg="6">
                  <p>{{ presumptiveDataEach.unique_number }}</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col lg="4">
              <v-row>
                <v-col class="header" lg="6">
                  <h3>Name</h3>
                </v-col>
                <v-col lg="6">
                  <p>{{ presumptiveDataEach.name }}</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col lg="4">
              <v-row>
                <v-col class="header" lg="6">
                  <h3>Age</h3>
                </v-col>
                <v-col lg="6">
                  <p>{{ presumptiveDataEach.age }}</p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="4">
              <v-row>
                <v-col class="header" lg="6">
                  <h3>Sex</h3>
                </v-col>
                <v-col lg="6">
                  <p v-if="presumptiveDataEach.sex == 1">Male</p>
                  <p v-else>Female</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col lg="4">
              <v-row>
                <v-col class="header" lg="6">
                  <h3>Case Found At</h3>
                </v-col>
                <v-col lg="6">
                  <p v-if="presumptiveDataEach.case_found_at_name">
                    {{ presumptiveDataEach.case_found_at_name.name }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <!-- show if it is family member -->
          <section v-if="
              Object.keys(familyMemberDataEach).length > 0 &&
                paramTypes.type == 'Family'
            "
          >
            <v-row>
              <v-col lg="4">
                <v-row>
                  <v-col class="header" lg="6">
                    <h3>Name</h3>
                  </v-col>
                  <v-col lg="6">
                    <p>{{ familyMemberDataEach.name }}</p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col lg="4">
                <v-row>
                  <v-col class="header" lg="6">
                    <h3>Age</h3>
                  </v-col>
                  <v-col lg="6">
                    <p>{{ familyMemberDataEach.age }}</p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col lg="4">
                <v-row>
                  <v-col class="header" lg="6">
                    <h3>Sex</h3>
                  </v-col>
                  <v-col lg="6">
                    <p v-if="familyMemberDataEach.sex == 1">Male</p>
                    <p v-else>Female</p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </section>
          <section v-else-if="paramTypes.type == 'Followup'">
            <v-row>
              <v-col lg="4">
                <v-row>
                  <v-col class="header" lg="6">
                    <h3>Name</h3>
                  </v-col>
                  <v-col lg="6">
                    <p>{{ paramTypes.name }}</p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col lg="4">
                <v-row>
                  <v-col class="header" lg="6">
                    <h3>DOB</h3>
                  </v-col>
                  <v-col lg="6">
                    <p>{{ paramTypes.dob }}</p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col lg="4">
                <v-row>
                  <v-col class="header" lg="6">
                    <h3>Sex</h3>
                  </v-col>
                  <v-col lg="6">
                    <p v-if="paramTypes.sex == 1">Male</p>
                    <p v-else>Female</p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </section>
          <!-- show if it is family member -->

          <v-row v-else-if=" paramTypes.id">
            <v-col lg="4">
              <label>Name</label>
              <v-text-field
              v-model="paramTypes.name"
                type="text"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col lg="4">
              <label>Age</label>
              <v-text-field
              v-model="paramTypes.age"
                type="number"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col lg="4">
              <label>Sex</label>
              <v-radio-group   v-model="paramTypes.sex" row>
                <v-radio label="Male" value="1"></v-radio>
                <v-radio label="Female" value="2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col lg="4">
              <label>Name</label>
              <v-text-field
                v-model.trim="name"
                type="text"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col lg="4">
              <label>Age</label>
              <v-text-field
                v-model.trim="age"
                type="number"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col lg="4">
              <label>Sex</label>
              <v-radio-group v-model="sex" row>
                <v-radio label="Male" value="1"></v-radio>
                <v-radio label="Female" value="2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        
          <v-row v-if="paramTypes.type == 'Followup'">
            <v-col lg="3">
              <label>Case Found At : Follow Up</label>
            </v-col>

            <template>
              <v-col lg="2">
                <label>MDRTB Reg Code</label>
                <v-text-field
                  v-model="paramTypes.index_case_no"
                  :disabled="paramTypes.type != 'New'"
                  outlined
                  dense
                  type="number"
                ></v-text-field>
              </v-col>

              <v-col lg="2">
                <label>MDRTB Reg Year</label>
                <v-text-field
                  v-model="paramTypes.index_case_year"
                  :disabled="paramTypes.type != 'New'"
                  outlined
                  dense
                  type="number"
                ></v-text-field>
              </v-col>

              <v-col lg="2">
                <label>MDRTB Reg Year</label>
                <v-text-field
                  v-model="paramTypes.index_case_year"
                  :disabled="paramTypes.type != 'New'"
                  outlined
                  dense
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col lg="2">
                <!-- <label 
                  >MDRTB Reg Initial</label
                > -->

                <!-- <v-select
                  v-model="parindex_case_initial"
                  :disabled="paramTypes.type != 'New'"
                  :items="InitialOpt"
                  item-text="text"
                  item-value="id"
                  dense
                  outlined
                ></v-select> -->
              </v-col>
              <v-col lg="3" v-show="case_found_at == 2 || case_found_at == 3">
                <label>Type of DRTB Contact</label>
                <v-select
                  v-model="relation"
                  :disabled="paramTypes.type != 'New'"
                  :items="relationOpt"
                  item-text="text"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </template>
          </v-row>
          <v-row v-else>
            <v-col lg="3">
              <label>Case Found At</label>
              <v-select
                v-model="case_found_at"
                :items="caseFoundAts"
                item-text="name"
                item-value="id"
                dense
                outlined
                :disabled="paramTypes.type != 'New'"
              ></v-select>
            </v-col>

            <template
              v-if="
                case_found_at == 2 || case_found_at == 3 || case_found_at == 5
              "
            >
              <v-col lg="2">
                <label v-if="paramTypes.type == 'Follow-up'"
                  >MDRTB Reg Code</label
                >
                <label v-else>Index Case Code</label>
                <v-text-field
                  v-model="index_case_no"
                  :disabled="paramTypes.type != 'New'"
                  outlined
                  dense
                  type="text"
                ></v-text-field>
              </v-col>

              <v-col lg="2">
                <label v-if="paramTypes.type == 'Follow-up'"
                  >MDRTB Reg Year</label
                >
                <label v-else>Index Case Year</label>
                <v-text-field
                  v-model="index_case_year"
                  :disabled="paramTypes.type != 'New'"
                  outlined
                  dense
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col lg="2">
                <label v-if="paramTypes.type == 'Follow-up'"
                  >MDRTB Reg Initial</label
                >
                <label v-else>Index Case Initial</label>
                <v-select
                  v-model="index_case_initial"
                  :disabled="paramTypes.type != 'New'"
                  :items="InitialOpt"
                  item-text="text"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col lg="2">
                <label>Mono-Poly</label>
                <v-select
                  v-model="index_case_monopoly"
                  :disabled="paramTypes.type != 'New'"
                  :items="monopoly"
                  item-text="text"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col lg="3" v-show="case_found_at == 2 || case_found_at == 3">
                <label>Relation</label>
                <v-select
                  v-model="relation"
                  :disabled="paramTypes.type != 'New'"
                  :items="relationOpt"
                  item-text="text"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </template>
          </v-row>
        </div>

        <!-- PATIENT INFO SECTION -->
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col lg="3">
            <label>Presumptive Township</label>
            <v-select
              :items="townships"
              v-model="supportingTownship"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col lg="3">
            <label>Referral From</label>
            <v-select
              :items="referralFromOpt"
              v-model="referral_from_id"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col lg="3" v-if="referral_from_id == 1">
            <label>Volunteer</label>
            <v-select
              v-model="volunteer_id"
              :items="volunteers"
              item-value="id"
              dense
              outlined
            >
              <template slot="selection" slot-scope="data">
                <!-- HTML that describe how select should render selected items -->
                {{ data.item.code }} ({{ data.item.name }})
              </template>
              <template slot="item" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                {{ data.item.code }} ({{ data.item.name }})
              </template>
            </v-select>
          </v-col>
          <v-col lg="3" v-if="referral_from_id == 1">
            <label>Referral Date</label>
            <v-menu
              ref="refMenu"
              v-model="refMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="referral_date"
                  outlined
                  dense
                  readonly
                  persistent-hint
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="referral_date"
                no-title
                @input="refMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col lg="4">
            <label>Refer \ Examine</label>
            <v-select
              :items="[
                { id: 1, name: 'Refer' },
                { id: 2, name: 'Examine' },
              ]"
              v-model="refer_or_examine"
              item-text="name"
              item-value="id"
              dense
              outlined
              :disabled="referral_from_id != 1"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <section v-show="refer_or_examine == 2">
      <!-- examine section -->
      <!-- REFERRAL,SYMPTON SECTION -->
      <v-card class="card--shadow">
        <v-card-text>
          <v-row>
            <v-col lg="4">
              <label>No</label>
              <v-text-field
                v-model.trim="no"
                type="text"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col lg="4">
              <label>Reg Date</label>
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="reg_date"
                    outlined
                    dense
                    readonly
                    persistent-hint
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="reg_date"
                  no-title
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col lg="4">
              <label>Referral Type</label>
              <v-select
                :items="referralTypeOpt"
                v-model="referral_type_id"
                item-text="name"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="6">
            <label>Weight(Kg)</label>
            <v-text-field
              v-model.trim="weight"
              outlined
              dense
              type="number"
            ></v-text-field>
          </v-col>
            <v-col lg="6">
              <label>Sympton</label>
              <v-select
                :items="symptonCustom"
                v-model="symptons"
                multiple
                item-text="name"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            
          </v-row>
        </v-card-text>
      </v-card>

      <!-- RISK FACTOR SECTION -->
      <v-card class="card--shadow">
        <v-card-text>
          <v-row>
            <v-col lg="8">
              <label>Risk Factors</label>
              <v-select
                :items="riskFactorCustom"
                v-model="risk_factors"
                multiple
                item-text="name"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- HIV SECTION -->
      <v-card class="card--shadow">
        <v-card-text>
          <v-row>
            <v-col lg="4">
              <label>HIV</label>
              <v-select
                :items="commonOpt"
                v-model="hiv_status"
                item-text="name"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col v-if="hiv_status == 3" lg="8">
              <v-row>
                <v-col class="col--padding" lg="4">
                  <label>Date</label>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="hiv_date"
                        outlined
                        dense
                        readonly
                        persistent-hint
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="hiv_date"
                      no-title
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="col--padding ml-1" lg="3">
                  <label>Result</label>
                  <v-select
                    :items="hivResult"
                    v-model="hiv_result"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col class="col--padding ml-1" lg="2">
                  <label>Code</label>
                  <v-text-field
                    v-model.trim="hiv_code"
                    type="text"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- SPUTUM SECTION -->
      <v-card class="card--shadow">
        <v-card-text>
          <v-row>
            <v-col lg="4">
              <label>Sputum</label>
              <v-select
                :items="commonOpt"
                v-model="sputum_status"
                item-text="name"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col v-if="sputum_status == 3" lg="8">
              <v-row>
                <v-col class="col--padding" lg="4">
                  <label>Date</label>
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="sputum_date"
                        outlined
                        dense
                        readonly
                        persistent-hint
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="sputum_date"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="col--padding ml-1" lg="3">
                  <label>Result</label>
                  <v-select
                    :items="sputumResult"
                    v-model="sputum_result"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- CXR SECTION -->
      <v-card class="card--shadow">
        <v-card-text>
          <v-row>
            <v-col lg="4">
              <label>CXR</label>
              <v-select
                :items="commonOpt"
                v-model="cxr_status"
                item-text="name"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col v-if="cxr_status == 3" lg="8">
              <v-row>
                <v-col class="col--padding" lg="4">
                  <label>Date</label>
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="cxr_date"
                        outlined
                        dense
                        readonly
                        persistent-hint
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="cxr_date"
                      no-title
                      @input="menu3 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="col--padding ml-1" lg="3">
                  <label>Result</label>
                  <v-select
                    v-model="cxr_result"
                    :items="cxrResult"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Gene Xpert SECTION -->
      <v-card class="card--shadow">
        <v-card-text>
          <v-row>
            <v-col lg="4">
              <label>Gene Xpert</label>
              <v-select
                :items="commonOpt"
                v-model="gene_xpert_status"
                item-text="name"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col v-if="gene_xpert_status == 3" lg="8">
              <v-row>
                <v-col class="col--padding" lg="4">
                  <label>Date</label>
                  <v-menu
                    ref="menu4"
                    v-model="menu4"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="gene_xpert_date"
                        outlined
                        dense
                        readonly
                        persistent-hint
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="gene_xpert_date"
                      no-title
                      @input="menu4 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="col--padding ml-1" lg="3">
                  <label>Result</label>
                  <v-select
                    :items="geneResult"
                    v-model="gene_xpert_result"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Culture SECTION -->
      <v-card class="card--shadow">
        <v-card-text>
          <v-row>
            <v-col lg="4">
              <label>Culture</label>
              <v-select
                :items="commonOpt"
                v-model="culture_status"
                item-text="name"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col v-if="culture_status == 3" lg="8">
              <v-row>
                <v-col class="col--padding" lg="4">
                  <label>Date</label>
                  <v-menu
                    ref="menu5"
                    v-model="menu5"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="culture_date"
                        outlined
                        dense
                        readonly
                        persistent-hint
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="culture_date"
                      no-title
                      @input="menu5 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="col--padding ml-1" lg="3">
                  <label>Result</label>
                  <v-select
                    v-model="culture_result"
                    :items="cultureResult"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- DST SECTION -->
      <v-card class="card--shadow">
        <v-card-text>
          <v-row>
            <v-col lg="3">
              <label>DST</label>
              <v-select
                :items="commonOpt"
                v-model="dst_status"
                item-text="name"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col v-if="dst_status == 3" lg="8">
              <v-row>
                <v-col class="col--padding" lg="4">
                  <label>Date</label>
                  <v-menu
                    ref="menu6"
                    v-model="menu6"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dst_date"
                        outlined
                        dense
                        readonly
                        persistent-hint
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dst_date"
                      no-title
                      @input="menu6 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="col--padding ml-1" lg="7">
                  <label>Result</label>
                  <v-select
                  v-model="computeDstResult"
                  multiple
                  :items="dstResult"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Other Investigation SECTION -->
      <v-card class="card--shadow">
        <v-card-text>
          <v-row>
            <v-col lg="4">
              <label>Other Investigation</label>
              <v-select
                :items="commonOpt"
                v-model="other_investigation_status"
                item-text="name"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col v-if="other_investigation_status == 3" lg="8">
              <v-row>
                <v-col class="col--padding" lg="4">
                  <label>Date</label>
                  <v-menu
                    ref="menu7"
                    v-model="menu7"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="other_investigation_date"
                        outlined
                        dense
                        readonly
                        persistent-hint
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="other_investigation_date"
                      no-title
                      @input="menu7 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="col--padding pl-2" lg="4">
                  <label>Test</label>
                  <v-text-field
                    v-model.trim="other_investigation_test"
                    type="text"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col class="col--padding pl-2" lg="4">
                  <label>Result</label>
                  <v-text-field
                    v-model.trim="other_investigation_result"
                    type="text"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Conclusion treatment,other comment SECTION -->
      <v-card class="card--shadow">
        <v-card-text>
          <v-row>
            <v-col lg="4">
              <label>Conclusion/Treatment Received</label>
              <v-select
                :items="conclusionsOpt"
                v-model="conclusion"
                item-text="name"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col lg="2">
              <label>Code</label>
              <v-text-field
                v-model.trim="conclusion_code"
                type="text"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="7">
              <label>Other Comment</label>
              <v-textarea
                rows="3"
                v-model="other_comment"
                placeholder="remark..."
                outlined
                dense
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- examine section -->
    </section>
    <v-card>
      <v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="emitPresumptiveData" class="form-btn">
            <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  props: {
    township_id: {
      type: String,
    },
    presumptiveDataEach: {
      type: Object,
    },
    familyMemberDataEach: {
      type: Object,
    },
    contactData:{
      type:Object,
    }
  },
  data: () => ({
    weight:null,
    menu: false,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menuDob: false,
    refMenu: false,
    name: null,
    sex: null,
    age: null,
    case_found_at: null,
    no: null,
    reg_date: null,
    index_case_no: null,
    index_case_year: null,
    index_case_initial: null,
    index_case_monopoly: null,
    relation: null,
    previousID: null,

    referral_type_id: null,
    referral_from_id: null,
    referral_date: null,
    volunteer_id: null,
    symptons: [],

    risk_factors: [],

    hiv_status: 1,
    hiv_date: null,
    hiv_result: null,
    hiv_code: null,

    sputum_status: 1,
    sputum_date: null,
    sputum_result: null,

    cxr_status: 1,
    cxr_date: null,
    cxr_result: null,

    gene_xpert_status: 1,
    gene_xpert_date: null,
    gene_xpert_result: null,

    culture_status: 1,
    culture_date: null,
    culture_result: null,

    dst_status: 1,
    dst_date: null,
    dst_result: null,

    other_investigation_test: 1,
    other_investigation_date: null,
    other_investigation_result: null,
    other_investigation_status: 1,

    conclusion: null,
    conclusion_code: null,

    other_comment: null,
    refer_or_examine: 1,
    family_member_id: null,
    supportingTownship: null,

    presumptive_id:null,
   
  }),
  watch: {
    referral_from_id() {
      if (this.referral_from_id != 1) {
        this.refer_or_examine = 2;
      }
    },
  },
  computed: {
    ...mapState("BasicData", [
      "commonOpt",
      "commonResultOpt",
      "InitialOpt",
      "relationOpt",
    ]),
    ...mapState("InfoData", ["monopoly"]),
    ...mapState("Volunteer", ["volunteers"]),
    ...mapState("Township", ["townships"]),
    ...mapGetters("BasicData", [
      "referralTypeOpt",
      "referralFromOpt",
      "symptonOpt",
      "riskFactorOpt",
      "conclusionsOpt",
      "caseFoundatOpt",
      "hivResult",
      "cxrResult",
      "dstResult",
      "geneResult",
      "sputumResult",
      "cultureResult",
    ]),
    computeDstResult: {
      get() {
        if(typeof this.dst_result === 'string'){
          return JSON.parse(this.dst_result)
        }
        return this.dst_result
      },
      set(val) {
        this.dst_result = val.map((v) => {
            return v
        })
      },
    },
    symptonCustom() {
      var data = [];
      if (this.symptonOpt) {
        this.symptonOpt.forEach((val) => {
          if (this.symptons.includes(14)) {
            this.symptons = [14];
            if (val.id == 14) data.push(val);
          } else {
            data.push(val);
          }
        });
      }
      return data;
    },
    riskFactorCustom() {
      var data = [];
      if (this.riskFactorOpt) {
        this.riskFactorOpt.forEach((val) => {
          if (this.risk_factors.includes(10)) {
            this.risk_factors = [10];
            if (val.id == 10) data.push(val);
          } else {
            data.push(val);
          }
        });
      }
      return data;
    },
    // conclusons() {
    //   var data = [];
    //   if (this.conclusionsOpt) {
    //     this.conclusionsOpt.forEach((val) => {
    //       if (val.id == 1 || val.id == 2) {
    //         if (this.sputum_result == 3) {
    //           data.push(val);
    //         }
    //         else if(this.cxr_result == 5){
    //           data.push(val);
    //         }
    //          else if (
    //           this.gene_xpert_result == 4 ||
    //           this.gene_xpert_result == 5
    //         ) {
    //           data.push(val);
    //         } else if (this.culture_result == 4) {
    //           data.push(val);
    //         } else if (val.id == 1 && this.cxr_result == 5) {
    //           data.push(val);
    //         }
    //       } else {
    //         data.push(val);
    //       }
    //     });
    //   }
    //   return data;
    // },
    caseFoundAts() {
      var data = [];
      if (this.caseFoundatOpt) {
        this.caseFoundatOpt.forEach((val) => {
          if (this.paramTypes.type == "New") {
            if (val.id == "4" || val.id == "6" ||  val.id == "7") {
              data.push(val);
            }
          } else if (this.paramTypes.type == "close-contact") {
            if (val.id == "3" ) {
              this.index_case_no = this.paramTypes.index_case_no;
              this.index_case_year = this.paramTypes.index_case_year;
              this.index_case_monopoly = this.convertMonopolyToId(this.paramTypes.index_case_monopoly);
              this.relation = 3;
              this.case_found_at = 3;
              data.push(val);
            }
          }
          else if (this.paramTypes.type == "other-contact") {
            if (val.id == "3" ) {
              this.index_case_no = this.paramTypes.index_case_no;
              this.index_case_year = this.paramTypes.index_case_year;
              this.index_case_monopoly = this.convertMonopolyToId(this.paramTypes.index_case_monopoly);
              this.relation = 4;
              this.case_found_at = 3;
              data.push(val);
            }
          }
           else if (this.paramTypes.type == "Family") {
            if (val.id == 3 ) {
              this.index_case_no = this.paramTypes.index_case_no;
              this.index_case_year = this.paramTypes.index_case_year;
              this.index_case_monopoly = this.convertMonopolyToId(this.paramTypes.index_case_monopoly);
              this.relation = 1;
              this.case_found_at = 3;
              this.family_member_id = this.paramTypes.family_member_id;
              data.push(val);
            }
          } else if (this.paramTypes.type == "Follow-up") {
            if (val.id == 5 ) {
              this.case_found_at = 5;
              this.index_case_no = this.paramTypes.index_case_no;
              this.index_case_year = this.paramTypes.index_case_year;
              this.index_case_monopoly = this.convertMonopolyToId(this.paramTypes.index_case_monopoly);
              data.push(val);
            }
          }
        });
      }

      return data;
    },
    paramTypes() {
      if (this.$route.params.type) return JSON.parse(this.$route.params.type);
      else return {};
    },
  },
  methods: {
    convertMonopolyToId(value) {
      // Convert string values to IDs, or return the ID if already an ID
      if (!value) return "2"; // Default to "Yes"
      
      // If it's already a valid ID (1, 2, 3, 4), return it
      if (value === "1" || value === "2" || value === "3" || value === "4") {
        return value;
      }
      
      // Convert string text to ID
      const monopolyMap = {
        "No": "1",
        "Yes": "2",
        "SG": "3",
        "MGY": "4",
      };
      
      return monopolyMap[value] || "2"; // Default to "Yes" if not found
    },
    validate() {
      let message = "";

      if (this.paramTypes.type == "New") {
        if (this.name == null) message += "Name is required\n";
        if (this.age == null) message += "Age is required\n";
        if (this.sex == null) message += "Sex is required\n";
      }

      if (
        this.paramTypes.type != "Times" &&
        this.paramTypes.type != "Followup"
      ) {
        if (this.case_found_at == null)
          message += "Case Found at is required\n";
      }

      if (this.referral_from_id == null)
        message += "Referral Form is is required\n";

      if (this.referral_from_id == 1) {
        if (this.referral_date == null)
          message += "Referral Date is required\n";
        if (this.volunteer_id == null) message += "Volunteer  is required\n";
      }

      if (this.refer_or_examine == 2) {
        if (this.no == null) message += "No  is required\n";
        if (this.reg_date == null) message += "Reg Date  is required\n";
        if (this.referral_type_id == null)
          message += "Referral Type  is required\n";

        if (this.sputum_status == 3) {
          if (this.sputum_date == null) message += "Sputum Date is required\n";
          if (this.sputum_result == null)
            message += "Sputum Result is required\n";
        }

        if (this.hiv_status == 3) {
          if (this.hiv_date == null) message += "Hiv Date is required\n";
          if (this.hiv_result == null) message += "Hiv Result is required\n";
        }

        if (this.cxr_status == 3) {
          if (this.cxr_date == null) message += "CXR Date is required\n";
          if (this.cxr_result == null) message += "CXR Result is required\n";
        }

        if (this.gene_xpert_status == 3) {
          if (this.gene_xpert_date == null)
            message += "Gene Xpert Date is required\n";
          if (this.gene_xpert_result == null)
            message += "Gene Xpert Result is required\n";
        }

        if (this.culture_status == 3) {
          if (this.culture_date == null)
            message += "Culture Date is required\n";
          if (this.culture_result == null)
            message += "Culture Result is required\n";
        }

        if (this.dst_status == 3) {
          if (this.dst_date == null) message += "DST Date is required\n";
          if (this.dst_result == null) message += "DST Result is required\n";
        }

        if (this.other_investigation_status == 3) {
          if (this.other_investigation_date == null)
            message += "Other Investigation Date is required\n";
          if (this.other_investigation_result == null)
            message += "Other Investigation Result is required\n";
        }

        if (this.symptons.length == 0) message += "Sympton is required\n";
        if (this.risk_factors.length == 0)
          message += "Risk Factor is required\n";

        if (this.conclusion == null) message += "Conclusion is required\n";
      }

      if ( this.weight >= 100) {
          message+= 'Weight cannot be greater than 100.\n';
        }

      if (message.length > 0) {
        this.$toast.error(message, {
          timeout: 2000,
        });
      }

      return message.length > 0 ? false : true;
    },
    emitPresumptiveData() {
     
      if (this.validate()) {
        let contact_name=this.paramTypes.id?this.paramTypes.name:this.name;
        let contact_age=this.paramTypes.id?this.paramTypes.age:this.age;
        let contact_sex=this.paramTypes.id?this.paramTypes.sex:this.sex;
        let contact_id=this.paramTypes.id?this.paramTypes.id:this.$route.params.id;

        let data = {
          township_id: this.$route.params.township_id,
          supporting_township: this.supportingTownship,

          no: this.no,
          name: contact_name,
          sex: contact_sex,
          age: contact_age,
          reg_date: this.reg_date,

          case_found_at: this.case_found_at,
          index_case_initial: this.index_case_initial,
          index_case_no: this.index_case_no,
          index_case_year: this.index_case_year,
          index_case_monopoly: this.index_case_monopoly,
          relation: this.relation,
          previousID: this.previousID,

          referral_type_id: this.referral_type_id,
          referral_from_id: this.referral_from_id,

          hiv_status: this.hiv_status,
          hiv_code: this.hiv_code,
          hiv_result: this.hiv_result,
          hiv_date: this.hiv_date,

          sputum_status: this.sputum_status,
          sputum_date: this.sputum_date,
          sputum_result: this.sputum_result,

          cxr_status: this.cxr_status,
          cxr_date: this.cxr_date,
          cxr_result: this.cxr_result,

          gene_xpert_status: this.gene_xpert_status,
          gene_xpert_date: this.gene_xpert_date,
          gene_xpert_result: this.gene_xpert_result,

          culture_status: this.culture_status,
          culture_date: this.culture_date,
          culture_result: this.culture_result,

          dst_status: this.dst_status,
          dst_date: this.dst_date,
          dst_result: this.dst_result,

          other_investigation_status: this.other_investigation_status,
          other_investigation_date: this.other_investigation_date,
          other_investigation_result: this.other_investigation_result,
          other_investigation_test: this.other_investigation_test,

          conclusion: this.conclusion,
          conclusion_code: this.conclusion_code,

          other_comment: this.other_comment,

          referral_date: this.referral_date,
          volunteer_id: this.volunteer_id,
          refer_or_examine: this.refer_or_examine,
          family_member_id: this.paramTypes
            ? this.paramTypes.family_member_id
            : "",
          presumptive_id: contact_id,
        };

        if (this.paramTypes.type == "Followup") {
          data.name = this.paramTypes.name;
          data.age = 22;
          data.sex = this.paramTypes.sex;
          data.case_found_at = 5;
          data.index_case_no = this.paramTypes.index_case_no;
          data.index_case_year = this.paramTypes.index_case_year;
        }

        const symptons = this.symptons.map((v) => {
          if (typeof v === "object") return v.id;
          return v;
        });
        const risk_factors = this.risk_factors.map((v) => {
          if (typeof v === "object") return v.id;
          return v;
        });
        data.symptons = symptons;
        data.weight = this.weight;
        data.risk_factors = risk_factors;

       this.$emit("emitPresumptiveData", data);
      }
    },
  },
  created() {
    this.$store.dispatch("Township/getAllTownships");
    this.$store.dispatch("BasicData/getBasicData");
    this.$store.dispatch(
      "Volunteer/getVolunteerByTwnId",
      this.$route.params.township_id
    );
  },
};
</script>

<style scoped>
.v-card {
  margin: 20px 0px !important;
}
h3,
p {
  margin: 0px;
}
.patient-detail h3,
p {
  font-size: 16px;
}
h3 {
  color: #453f3f;
  letter-spacing: 1px;
  font-weight: 400;
}
.header {
  background-color: #e6e6e6;
  border-radius: 5px;
}
</style>
